(ns quuppa.peweb.peinfo-tags
  (:require [clojure.string :as str]
            [goog.object :as gobj]
            [linked.core :as l]
            [quuppa.qsm.permissions-access :as permissions-access]
            [quuppa.qsm.subs :as qsm-subs]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [quuppa.components :as c]
            [quuppa.date-time.core :as date-time]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.ui.layout :as layout]
            [quuppa.peweb.peinfo-events :as e]
            [quuppa.peweb.tables :as tables]
            [quuppa.peweb.tags.subs :as tags]
            ["react-window" :refer [FixedSizeList]]
            ["react-use-measure$default" :as useMeasure]
            ["react-virtualized-auto-sizer$default" :as AutoSizer]))

;; React-virtuoso would have built-in support for calculating height for every row.
;; Currently, not needed.
;; React-window also allows us to calculate height for each row ourselves.

(defn location-str [[x y z :as loc]]
  (when loc
    (str (.toFixed x 3) ", " (.toFixed y 3) ", " (.toFixed z 3))))

(def position-events-disabled-message
  "QSM is set to not receive location events from the QPE.")

;; - Sorting uses value-fn.
;; - Display uses render-fn value-fn.
;; - Width is "grow factor", kind of like with flexbox.
;;   Final col width is (table-width-px * (col-width / total-col-widths))

;; Note: check qpe-next quuppa.domain/get-tag-ui-configuration-data for old list of tag columns.
(def tag-columns
  (l/map
    :id
    {:value-fn :resolved-id
     :sortable true
     :width 10
     :label "ID"
     :always-selected true}

    :name
    {:value-fn :name
     :sortable true
     :width 12
     :label "Name"}

    :color
    {:value-fn  :color
     :render-fn (fn [c]
                  [:<>
                   [:div.qi-circle
                    {:style {:color c}
                     :title c}]
                   [:small.ml-2 c]])
     :sortable  true
     :width     7
     :label     "Color"}

    ; :calculation-date
    ; {:value-fn (fn calculation-date-field [v] (-> v :location :calculation-date))
    ;  :render-fn date-time/format-date
    ;  :sortable true
    ;  :width 12
    ;  :label "Date"}

    :last-seen
    {:label "Last seen"
     :sortable true
     :width 12
     :value-fn :last-seen
     :render-fn c/date-time}

    ;; Same as lastSeenTS?
    :location-date
    {:value-fn (fn location-date-field [v] (-> v :location :location-date))
     :render-fn c/timeago
     :sortable true
     :width 12
     :label "Location date"}

    :location-type
    {:value-fn (fn cs-id-field [v] (-> v :location :type))
     :sortable true
     :width 10
     :label "Location type"}

    :stationary
    {:value-fn (fn cs-id-field [v] (-> v :location :stationary))
     :sortable true
     :width 10
     :label "Stationary"}

    :coordinate-system
    {:value-fn (fn cs-id-field [v ctx]
                 (when-let [cs-id->name (:cs-id->name ctx)]
                   (-> v :location :cs-id cs-id->name)))
     :sortable true
     :width 10
     :label "Coordinate system"}

    :position
    {:value-fn (fn position-field [v] (-> v :location :position))
     :render-fn location-str
     :width 15
     :sortable true
     :label "Position"}

    :radius
    {:value-fn (fn position-field [v] (-> v :location :radius))
     :render-fn #(when %
                   (str (.toFixed % 2) " m"))
     :width 5
     :sortable true
     :label "Radius"}

    ; [:covariance-matrix #(-> % :location :covariance-matrix str)]

    :device-address
    {:value-fn :device-address
     :width 10
     :sortable true
     :label "Device address"}))

(def extra-columns
  (l/map
    :tag-group-name
    {:label "Tag group name"
     :sortable true
     :value-fn :group}

    :fw-version
    {:label "Firmware version"
     :sortable true
     :value-fn :fw-version}

    :battery-alarm
    {:label "Battery alarm"
     :sortable true
     :value-fn :battery-alarm}

    :last-battery-low-ts
    {:label "Last batter low TS"
     :value-fn :battery-alarm-date
     :sortable true
     :render-fn date-time/format-instant}

    :battery-voltage
    {:label "Battery voltage"
     :sortable true
     :value-fn :battery-voltage}

    :button-1-state
    {:label "Button 1 state"
     :sortable true
     :value-fn :button-1-state}

    :button-1-ts
    {:label "Button 1 last press time"
     :sortable true
     :value-fn :button-1-last-date
     :render-fn date-time/format-instant}

    :rssi
    {:label "RSSI"
     :sortable true
     :value-fn :rssi}

    :rssi-locator-count
    {:label "RSSI Locator count"
     :sortable true
     :value-fn :rssi-locator-count}

    :tag-state
    {:label "Tag state"
     :sortable true
     :value-fn :tag-state}

    :state-transition
    {:label "State transition"
     :sortable true
     :value-fn :tag-state-transition}

    :trigger-count
    {:label "Trigger count"
     :sortable true
     :value-fn :trigger-count}

    :tx-power
    {:label "TX power"
     :sortable true
     :value-fn :tx-power}

    :tx-rate
    {:label "TX Rate"
     :sortable true
     :value-fn (fn [v] (-> v :location :tx-rate))}

    :io-states
    {:label "IO States"
     :sortable true
     :value-fn :io-states
     :render-fn (fn [states] (str/join ", " states))}

    :config-status
    {:label "Config status"
     :sortable true
     :value-fn :config-status}

    :current-config-value-name
    {:label "Current config value name"
     :sortable true
     :value-fn :current-config-value-name}

    :current-config-value-channel
    {:label "Current config value channel"
     :sortable true
     :value-fn :current-config-value-channel}

    :target-config-value-name
    {:label "Target config value name"
     :sortable true
     :value-fn :target-config-value-name}

    :target-config-value-channel
    {:label "Target config value channel"
     :sortable true
     :value-fn :target-config-value-channel}))

(def all-columns (into tag-columns extra-columns))
(def default-columns (into #{} (keys tag-columns)))

(defn column->value [{:keys [value-fn]} tag ctx]
  (if (keyword? value-fn)
    (value-fn tag)
    (value-fn tag ctx)))

;; Because location is subscribed only on the single row component,
;; and only those rows are rendered that shown on the screen,
;; we only follow those location updates that are shown on the screen.
;; => FAST!

(defn tag-row [{:keys [index style data]}]
  (let [{:keys [qpe-subscribe qpe-identity _qpe-dispatch get-item table-width selected-columns-width selected-columns]} data
        tag (get-item index)
        tag (assoc tag :location @(rf/subscribe [::tags/tag-location qpe-identity tag]))
        cs-id->name @(qpe-subscribe [::cs-id->name])
        value-fn-ctx {:cs-id->name cs-id->name}]
    [:div.tag-row.d-flex.flex-row.div-table-row
     {; :on-click #(qpe-dispatch [:qpe/assoc-in [:ui :sidebar]
      ;                           {:type :tag-details :tag-id (:resolved-id tag)}])
      ;; Style is JS object here, but it works.
      :style style}
     (for [[column-id {:keys [render-fn width]
                       :or {render-fn identity}
                       :as column}] all-columns
           :when (contains? selected-columns column-id)
           :let [value (column->value column tag value-fn-ctx)
                 text (render-fn value)]]
       [:div.div-table-cell
        {:key column-id
         :style {:width (tables/width-fn table-width selected-columns-width width)}}
        [:div.text-truncate text]
        [:div.cell-full-value text]])]))

(defn tag-row-wrapper [js-props]
  (r/as-element [tag-row {:index (.-index js-props)
                          :style (.-style js-props)
                          :data (.-data js-props)}]))

;; If just sort-field or order changes, no need to run filter again.

(rf/reg-sub ::filtered-tags
  (fn [[_ qpe-identity _search-string]]
    (rf/subscribe [:qpe/data qpe-identity :tags :info]))
  (fn sub-filtered-tags [tags [_ _qpe-identity search-string]]
    (cond->> (vals tags)
      search-string (filter (fn [tag] (str/includes? (:resolved-id tag) search-string))))))

(rf/reg-sub ::cs-id->name
  (fn [[_ qpe-identity]]
    (rf/subscribe [:qpe/data qpe-identity :current-project :cs-maps]))
  (fn [cs-maps _]
    (into {} (map (juxt :id :name) (vals cs-maps)))))

(rf/reg-sub ::sorted-tags
  (fn [[_ qpe-identity search-string _sort-field _sort-order]]
    [(rf/subscribe [::filtered-tags qpe-identity search-string])
     (rf/subscribe [::cs-id->name qpe-identity])])
  (fn sub-sorted-tags [[filtered-tags cs-id->name] [_ _qpe-identity _search-string sort-field sort-order]]
    (let [column (get all-columns sort-field)
          value-fn-ctx {:cs-id->name cs-id->name}]
      (if-let [tags (not-empty filtered-tags)]
        (cond-> (sort-by (fn [tag]
                           (column->value column tag value-fn-ctx))
                         tags)
          (not sort-order) reverse)
        []))))

; (rf/reg-sub ::results
;   (fn [[_ qpe-identity search-string sort-field sort-order _results]]
;     (rf/subscribe [::sorted-tags qpe-identity search-string sort-field sort-order]))
;   (fn sub-results [sorted-tags [_ _qpe-identity _search-string _sort-field _sort-order results]]
;     (vec (take results sorted-tags))))

(rf/reg-sub
  ::tag-by-id
  (fn [[_ qpe-identity]]
    (rf/subscribe [:qpe/data qpe-identity :tags :info]))
  (fn sub-filtered-tags [tags [_ _qpe-identity tag-id]]
    (get tags tag-id)))

(rf/reg-event-fx
  :qpe/set-tag-attribute
  (fn [_ [_ qpe-identity tag-id attribute value]]
    {:fx [[:qpe-dispatch {:qpe-identity qpe-identity
                          :event        [:qpe/set-tag-attribute [tag-id attribute value]]}]]}))

(defn tag-parameters-form [{:keys [qpe-dispatch]} tag]
  (let [current-user @(rf/subscribe [::qsm-subs/user])
        current-user-role (permissions-access/get-user-role current-user)]
    [:div.d-flex.flex-column.p-3
     [:span
      [:strong "Color:"]
      [:span.px-3 (:color tag)]

      [:input {:type      "color"
               :value     (:color tag)
               :on-change #(qpe-dispatch [:qpe/set-tag-attribute (:resolved-id tag) :color (.. % -target -value)])}]]
     (when-not (= current-user-role "member")
       [:div.form-group
        [:strong "Name"]
        [:input.form-control
         {:type "text"
          :default-value (:name tag)
          :on-blur #(qpe-dispatch [:qpe/set-tag-attribute (:resolved-id tag) :name (.. % -target -value)])}]])]))

(defn tag-parameters-sidebar [{:keys [qpe-dispatch] :as props} tag]
  [:div.sidebar
   [:div.sidebar-header
    [:h4.flex-grow-1 (:id tag)]
    [:button
     {:on-click #(qpe-dispatch [:qpe/close-sidebar])}
     [icon :close]]]

   [tag-parameters-form props tag]])

(defn sidebar [{:keys [qpe-subscribe parameters] :as props}]
  (or (when-let [sidebar-type @(qpe-subscribe [:qpe/data :ui :sidebar :type])]
        ;; This is disabled atm
        (case sidebar-type
          :tag-details
          (let [tag-id @(qpe-subscribe [:qpe/data :ui :sidebar :tag-id])
                tag @(qpe-subscribe [::tag-by-id tag-id])]
            {:key tag-id}
            [tag-parameters-sidebar props tag])

          nil))
      (when-let [sidebar-type (-> parameters :query :panel)]
        (case sidebar-type
          :tag-columns
          [tables/columns-sidebar
           props
           {:k :tag-columns
            :all-columns all-columns
            :default-columns default-columns}]
          nil))))

(defn tag-grid [_]
  (let [search-string (r/atom "")]
    (fn [{:keys [qpe-subscribe qpe-dispatch qpe-identity parameters] :as props}]
      (let [[table-ref bounds] (useMeasure)
            sort-by-field (-> parameters :query (:sort-field :id))
            sort-order-asc (-> parameters :query (:sort-asc true))
            results @(qpe-subscribe [::sorted-tags @search-string sort-by-field sort-order-asc])

            selected-columns (or @(qpe-subscribe [:qpe/data :ui :tag-columns])
                                 default-columns)
            selected-columns-width (->> selected-columns
                                        (map (fn [c]
                                               (:width (get all-columns c) 5)))
                                        (reduce + 0))]

        [layout/section
         [layout/view-content
          {:sidebar-open (or (:panel (:query parameters))
                             @(qpe-subscribe [:qpe/data :ui :sidebar :type]))}
          [layout/view-header
           {:title "Tags"}]

          [:div.d-flex.flex-row.justify-content-between.py-2
           [:div.d-flex.flex-row.align-items-center.flex-grow-1
            [:span.mr-4
             "Search: "]

            [:input.form-control.w-25
             {:type      "text"
              :value     @search-string
              :on-change #(reset! search-string (.. % -target -value))}]

            [:span.ml-4 "Showing " (count results) " tags"]]

           [:div.btn-toolbar.mx-n2
            [:button.btn.btn-outline-primary.mx-2
             {:on-click #(qpe-dispatch [::e/open-panel :tag-columns])}
             [icon :sliders.mr-3]
             "Columns"]]]

          ;; The check will never be true on QPE-next because the data doesn't exist.
          (when (false? @(qpe-subscribe [:qsm/qpe-configuration-value :enable-position-events]))
            [:div.alert.alert-warning
             {:key "alert"}
             position-events-disabled-message])

          [tables/table-header
           {:bounds                 bounds
            :all-columns            all-columns
            :selected-columns       selected-columns
            :sort-by-field          sort-by-field
            :sort-order-asc         sort-order-asc
            :selected-columns-width selected-columns-width}]

          [:div.d-flex.flex-column
           ;; flex-basic 0 to ensure this container doesn't
           ;; use auto height based on the contents height.
           {:ref   table-ref
            :style {:flex "1 0 0"}}
           [(r/adapt-react-class AutoSizer)
            {}
            (fn [dims]
              (let [height (gobj/get dims "height")
                    width  (gobj/get dims "width")]
                (r/create-element
                  FixedSizeList
                  ;; Force scrollbar because header presumes that.
                  #js {:style     #js {:overflowY "scroll"}
                       :itemCount (count results)
                       :itemSize  32
                       :itemKey   (fn [i _data]
                                    (:resolved-id (nth results i)))
                       :itemData  {:qpe-subscribe          qpe-subscribe
                                   :qpe-dispatch           qpe-dispatch
                                   :qpe-identity           qpe-identity
                                   :get-item               (fn [i] (nth results i))
                                   :table-width            width
                                   :selected-columns       selected-columns
                                   :selected-columns-width selected-columns-width}
                       :height    (max 100 height)
                       :width     width}
                  tag-row-wrapper)))]]]
         [sidebar props]]))))

(def query-params tables/query-params)
